import hdrm from '../../hdrm';
import template from '../../template';
import { connectedStore } from '../../store';

const isEmpty = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const pageContainerSelector = template.selectors.getPageContainerSelector(state);

  if (!pageContainerSelector) return false;

  const staticDocument = hdrm.instance.driver.getStaticDocument();
  const element = staticDocument.querySelector(pageContainerSelector);

  return Boolean(element) && element.childElementCount === 0;
};

export default isEmpty;
